import { GetPasswordValidation } from './types';

const getPasswordValidation: GetPasswordValidation = (validationCriteria) => [
	{
		name: 'min',
		isMet: validationCriteria.isWithinMinLimit,
		content: 'At least 8 characters',
	},
	{
		name: 'lowercase',
		isMet: validationCriteria.isIncludesLowercase,
		content: 'At least 1 lowercase letter',
	},
	{
		name: 'uppercase',
		isMet: validationCriteria.isIncludesUppercase,
		content: 'At least 1 capital letter',
	},
	{
		name: 'number',
		isMet: validationCriteria.isIncludesNumber,
		content: 'At least 1 number',
	},
	{
		name: 'special',
		isMet: validationCriteria.isIncludesSpecialChar,
		content: 'At least 1 special character (!@#$%^&*)',
	},
];

export default getPasswordValidation;
